import { Col, Container, Row } from 'react-bootstrap';
import { m } from 'framer-motion';
import { fadeIn } from '../../../Litho/Functions/GlobalAnimations';
import Counter from '../../../Litho/Components/Counters/Counter';
import Tab01 from '../../../Litho/Components/Tab/Tab01';

const counterData = [
	{
		number: { text: '350' },
		title: 'Flights per week',
		content: 'Scheduled and express capacity',
	},
	{
		number: { text: '120' },
		title: 'Countries served',
		content: 'Global network reach',
	},
];

const tabData = [
	{
		tabTitle: '01. BOOKING',
		subtitle: 'Simple, fast onboarding',
		title: 'Confirm capacity and schedule instantly',
		img: 'assets/img/services/air-freight-2.webp',
		content:
			'Share cargo details and preferred timings. We secure airline space and coordinate pickup.',
		buttonTitle: 'Start booking',
		buttonLink: '#',
	},
	{
		tabTitle: '02. PICKUP',
		subtitle: 'Secure handling',
		title: 'Origin pickup and export customs',
		img: 'assets/img/services/air-freight-3.jpg',
		content:
			'We arrange pickup, consolidation, and export clearance while keeping you updated.',
		buttonTitle: 'Learn more',
		buttonLink: '#',
	},
	{
		tabTitle: '03. AIR TRANSIT',
		subtitle: 'Priority movement',
		title: 'Real-time tracking during flight',
		img: 'assets/img/services/air-freight-4.jpg',
		content:
			'Milestone tracking across flights and hubs with proactive exception management.',
		buttonTitle: 'Tracking portal',
		buttonLink: '#',
	},
	{
		tabTitle: '04. DELIVERY',
		subtitle: 'Last-mile excellence',
		title: 'Import clearance and final delivery',
		img: 'assets/img/services/air-freight-5.jpeg',
		content:
			'We clear imports and deliver to destination, door-to-door if needed.',
		buttonTitle: 'Get a quote',
		buttonLink: '#',
	},
];

const PerformanceSection = () => {
	return (
		<m.section
			className='py-[130px] lg:py-[95px] md:py-[75px] sm:py-[50px] overflow-hidden'
			{...fadeIn}
		>
			<Container>
				<Row className='items-center'>
					<Col md={5} className='sm:mb-[30px]'>
						<h5 className='font-serif font-medium text-darkgray mb-0'>
							Reliable performance and global reach
						</h5>
					</Col>
					<Col lg={{ span: 6, offset: 1 }} md={7}>
						<Counter
							as='h5'
							theme='counter-style-01'
							grid='row-cols-1 row-cols-md-2 row-cols-sm-2 gap-y-10'
							className='text-black'
							duration={7}
							data={counterData}
							postfix_sign='+'
						/>
					</Col>
					<Col>
						<div className='w-full h-[1px] bg-mediumgray mt-28 mb-32 sm:my-20'></div>
					</Col>
				</Row>
				<Row className='justify-center'>
					<Col lg={11}>
						<Tab01 data={tabData} />
					</Col>
				</Row>
			</Container>
		</m.section>
	);
};

export default PerformanceSection;
